import { paths } from '~/__generated__/botco-api-schema';

import { axiosClient } from '../axiosClient';

type PathUrl = Required<paths['/chatbot/simulate/enqueue']['post']>;
type Body = PathUrl['requestBody']['content']['application/json'];
type Query = PathUrl['parameters']['query'];

type Request = {
  body: Body;
  params: Query;
};

export const chatbotSimulate = ({ body, params }: Request) => {
  return axiosClient.post<never>('/chatbot/simulate/enqueue', body, {
    params,
  });
};
